"use client";

import Script from "next/script";
import { useId } from "react";

type TTWidgetProps = {
  scriptUrl: string;
  sub?: string;
  customParams?: Record<string, unknown>;
};

const TTWidget = ({ scriptUrl, sub, customParams }: TTWidgetProps) => {
  const containerId = `tt-widget-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;

  const code = `window.ttwidget && window.ttwidget.load({
      type: "custom",
      sub: ${JSON.stringify(sub || "")},
      ${customParams ? `customParams: ${JSON.stringify(customParams)},` : ""}
      containerId: containerId,
    });`;

  return (
    <div className="tt-widget dark:bg-static-white dark:p-2 dark:rounded-md">
      <div id={containerId} />
      <Script
        src={scriptUrl}
        strategy="afterInteractive"
        onReady={() => {
          try {
            // eslint-disable-next-line no-new-func
            new Function("containerId", code)(containerId);
          } catch (error) {
            console.error("Failed to load embed widget:", error);
          }
        }}
      />
      <p className="text-xs text-gray-400 dark:text-gray-600 mt-1 text-right italic">
        Grafik från TT
      </p>
    </div>
  );
};

export default TTWidget;
